/*---------------------------------------------------------*\
 * Imports
 \*---------------------------------------------------------*/
import angular from 'angular';
import _ from 'lodash';
import crypto from 'crypto-js';

/*---------------------------------------------------------*\
 * userbillingService
 \*---------------------------------------------------------*/


function billingService(laboxSSapi,storage,authService) {

  this.setOOLSession = () => {
      return authService.trustedLogin().then((res) => {
        if(res && res!=null){
          console.log('Login done and response is ', res);
          storage.setItem('session', 'loginInfo', res.data);
          storage.setItem('session', 'oolsession', 'oolsession=' + res.data.oolsession);
          storage.setItem('session', 'accno', res.data.accountNumber);
          storage.setItem('session','hasOptimumId',true);
          return true;
        }
        else{
          console.log('login done with failure with resp---> ',res);
          //calling mallik api for account
          return laboxSSapi.accountInfo().then((res) =>{
            console.log('response of account info from mallik when primary id not available from login API --> ',res);
            if(res && res.data && res.data.accountNumber){
              storage.setItem('session', 'accno', res.data.accountNumber);
              storage.setItem('session','hasOptimumId',false);
              console.log('account number with mallik api',res.data.accountNumber );
              return true;
            }
            else{
              console.log('account info fail from mallik api also.');
              return null;
            }
          },(reserr)=>{
            console.log('account info also fail ---> ',reserr);
            return null;
          });
        }
      },(reserr)=>{
          console.log('Trusted Login fail with response----> ', reserr);
          return null;
      });
  };

  this.getbpebillData= () =>{
    var checkOOLSession = storage.getItem('session','oolsession');
    console.log('available ',checkOOLSession);
    if(checkOOLSession){
      return this.getbpebillinfo(checkOOLSession);
    }
    else{
      return this.setOOLSession().then(()=>{
        var getOOLSession = storage.getItem('session','oolsession');
        console.log('not available',getOOLSession);
        return this.getbpebillinfo(getOOLSession);
      });
    }
  };

  this.getbpebillinfo= (oolsessionId) =>{
    var data = {"sessionCookie":oolsessionId};
    return laboxSSapi.wrap("/api/ebill/info", {},'getbpebillinfo','POST',data);
  };

  this.getCurrectAcc = () =>{
    return this.getbpebillData().then((res)=>{
      var account = null;
      console.log('this is ebill info --> ',res);
      if (res && res.data.ebillInformationOutputs) {
        var accounts = res.data.ebillInformationOutputs;
        for (var i in accounts) {
          var temp = accounts[i];
          if(temp.accountNum == storage.getItem('session','accno')) {
            storage.setItem('session','curr_acc',temp);
            account = temp;
          }
        }
      }
      return account;
    });
  };

  this.generatePayloadBpGlobal=()=>{
    var accno = storage.getItem('session', 'accno');
    var homeid = storage.getItem('session', 'home_id');
    var rtime =  new Date().getTime();
    var secretAndKey = this.getConfig();
    // var secretKeyId = laboxSSapi.config.dev.bpKeySecretID;
    var secretKeyId = secretAndKey.bpKeySecretID;
    var query = "accountNumber="+accno+"&homeId="+homeid+"&requestTime="+rtime+"&secretKeyId="+secretKeyId;
    var path = "/billpay/bpGlobalNoSession?"+query;
    var hmac = crypto.HmacSHA256(path, secretAndKey.bpKeySecret).toString();
    var payload = query+"&hmac="+hmac;
    return payload;
  };

  this.getBpGlobalData = () => {
    if (storage.getItem('session', 'accno')) {
      var generatePayload = this.generatePayloadBpGlobal();
      console.log('payload', generatePayload);
      return this.getBpGlobalInfo(generatePayload);
    }
    else{
      return this.setOOLSession().then(()=>{
        if(storage.getItem('session', 'accno')){
          var generatePayload = this.generatePayloadBpGlobal();
          console.log('payload', generatePayload);
          return this.getBpGlobalInfo(generatePayload);
        }
        else{
          console.log('trusted login and mallik call are failed to load account number and so no bp global..');
          return null;
        }
      });
    }
  };

  this.getBpGlobalInfo= (data) =>{
    /*return laboxSSapi.wrap(laboxSSapi.config.dev.cassservice+"billpay/bpGlobalNoSession", {headers: {
        'Content-Type': 'application/x-www-form-urlencoded'}
    },'getBpGlobalInfo','POST',data); */
    var dataPayload = {"payload":data};
    return laboxSSapi.wrap('/api/bpglobal/nosession',{},'getBpGlobalInfo','POST',dataPayload);
  };

  this.submitotpayment = (pmName, amount) =>{
    if (storage.getItem('session', 'oolsession')) {
      var account = this.getCurrectAcc();
      if(account){
        var now = new Date();
        var data = "payNickname="+encodeURI(pmName);
        data += "&payAmount="+amount;
        data += "&payDate=" + ((now.getMonth()+1) + "/" + now.getDate() + "/" + now.getFullYear());
        data += "&isImmediate=1&isTCAccepted=true&system=laBox";
        var dataObj = {
          "sessionCookie":storage.getItem('session', 'oolsession'),
          "payload" : data
        };
        return this.submitPayment(dataObj);
      }
    }
    else{
      this.setOOLSession().then(()=>{
        var account = this.getCurrectAcc();
        if(account){
          var now = new Date();
          var data = "payNickname="+encodeURI(pmName);
          data += "&payAmount="+amount;
          data += "&payDate=" + ((now.getMonth()+1) + "/" + now.getDate() + "/" + now.getFullYear());
          data += "&isImmediate=1&isTCAccepted=true&system=laBox";
          var dataObj = {
            "sessionCookie":storage.getItem('session', 'oolsession'),
            "payload" : data
          };
          return this.submitPayment(dataObj);
        }
      });
    }
  };

  this.submitPayment= (data) =>{
    return laboxSSapi.wrap("/api/submit/payment", {},'submitPayment','POST',data);
  };

  this.deauthInfo = (billPayCache) =>{
      var result = {};
      result.deAuthStartDate = billPayCache.deAuthStartDate;
      result.deAuthBalanceDue = billPayCache.deAuthBalanceDue;
      result.isDeauth = false;
      result.isDeauthOne =false;
      result.isDeauthTwo = false;
      if (result.deAuthStartDate != null && result.deAuthBalanceDue != null && result.deAuthBalanceDue != 0) {
        result.isDeauth = result.deAuthBalanceDue > 0;
        var deauthDate = new Date(result.deAuthStartDate);
        var month = (deauthDate.getMonth() + 1);
        var date = deauthDate.getDate();
        result.startDate = (month > 9 ? "" : "0") + month + "/" + (date > 9 ? "" : "0") + date;
        result.isDeauthStarted = (result.deAuthStartDate < new Date().getTime());
        if(result.isDeauth && !result.isDeauthStarted){
          result.isDeauthOne = true;
        }
        if(result.isDeauth && result.isDeauthStarted){
          result.isDeauthTwo = true;
        }
      }
      return result;
  };

  this.enrollPaperlessBill = (paperBillInd, email)=> {
    return this.getCurrectAcc().then((resp)=>{
      if(resp){
        var data = "origPaperBillInd="+resp.isPaperBill;
        data += "&origMailNotifyInd="+resp.mailNotifyInd;
        data += "&origEmail="+resp.email;
        data += "&paperBillInd="+paperBillInd;
        data += "&mailNotifyInd="+resp.mailNotifyInd;
        data += "&email="+(email == null ? resp.email : email.toLowerCase());
        data += "&system=laBox";

        var dataObj = {
          "sessionCookie":storage.getItem('session', 'oolsession'),
          "payload" : data
        };
        return laboxSSapi.wrap("/api/enroll/paperless", {},'enrollPaperless','POST',dataObj);
      }
      else{
        return null;
      }
    });
  };

  this.getConfig = () => {
    if (storage.getItem('session', 'env') === 'prod') {
      return laboxSSapi.config.prod;
    } else if (storage.getItem('session', 'env') === 'stage') {
      return laboxSSapi.config.stage;
    } else {
      return laboxSSapi.config.dev;
    }
  };

}

billingService.$inject = [
  'laboxSSapi',
  'storage',
  'authService'
];

const api = angular.module('userbillingService', ['labox.sse.api','storage'])
  .service('billingService', billingService);

export default api;



// WEBPACK FOOTER //
// ./client/app/services/userbilling.js